/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router';
import Select from 'react-select';

import NotebookCard from './NotebookCard';
import Paginator from './Paginator';

import { getQueryValue, selectStyle } from '../../lib/utils';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/notebook-cards.scss';

const propTypes = {
    items: AppPropTypes.pages,
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
        }),
    ),
    pagination: PropTypes.shape({
        currentPage: PropTypes.number.isRequired,
        lastPage: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
    }).isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    tags: [{ id: 1 }, { id: 2 }],
    className: null,
};

const NotebookCards = ({ items, tags, pagination, className }) => {
    const history = useHistory();
    const location = useLocation();
    const options = [{ value: null, label: 'Tous les sujets' }].concat(
        tags.map(t => ({ value: t.slug, label: t.label })),
    );
    const slug = getQueryValue(location, 'slug') || null;

    const changeTag = useCallback(item => {
        if (item && item.value) {
            history.push(`/carnet/tags/${item.value}?slug=${item.value}`);
        } else {
            history.push(`/carnet`);
        }
    });

    const paginationClick = useCallback(
        page => {
            if (slug) {
                history.push(`/carnet/tags/${slug}/pages/${page}?slug=${slug}`);
            } else {
                history.push(`/carnet/pages/${page}`);
            }
        },
        [slug],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.select}>
                <Select
                    onChange={changeTag}
                    value={options.find(o => o.value === slug)}
                    options={options}
                    isMulti={false}
                    placeholder="Tous les sujets"
                    styles={selectStyle}
                />
            </div>
            <div className={styles.items}>
                {items.map((evt, i) => (
                    <NotebookCard
                        className={styles.single}
                        key={`notebook-card-${i + 1}`}
                        {...evt}
                        index={i}
                    />
                ))}
            </div>
            <div className={styles.pagination}>
                <Paginator {...pagination} onClick={paginationClick} />
            </div>
        </div>
    );
};

NotebookCards.propTypes = propTypes;
NotebookCards.defaultProps = defaultProps;

export default NotebookCards;
